window.addEventListener('DOMContentLoaded', function () {
  scrollIn();
});

function scrollIn(){
  scrollInEvent();
  var timer = false;
  $(window).scroll( function(){
    scrollInEvent();
  });
}

function scrollInEvent(){
  var distance = 200;
  if($('html').hasClass('isSP')) {
    distance = 30;
  }
  $('.c-fadein').each(function(){
    var elemPos = $(this).offset().top;
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll > elemPos - windowHeight + distance){
      $(this).addClass('c-scrollin');
    }else {
      $(this).removeClass('c-scrollin');
    }
  });

  headerResize();
}

function headerResize() {
  var scroll = $(window).scrollTop();
  if (scroll === 0) {
    $('.l-header').addClass('big');
  } else {
    $('.l-header').removeClass('big');
  }
}
